import type { RouteRecordRaw } from 'vue-router'

export const tabHomeRoutes: RouteRecordRaw[] = [
  {
    path: '/tab-home',
    name: 'tab-home',
    component: () => import('@/pages/TabHome/index.vue'),
    redirect: '/tab-home/home',
    meta: { backMode: 'exit' },
    children: [
      {
        path: 'home',
        name: 'tab-home-home',
        component: () => import('@/pages/Home/index.vue'),
      },
      {
        path: 'content',
        name: 'tab-home-content',
        component: () => import('@/pages/Content/index.vue'),
      },
      {
        path: 'profile',
        name: 'tab-home-profile',
        component: () => import('@/pages/Profile/index.vue'),
      },
      {
        path: 'me',
        name: 'tab-home-me',
        component: () => import('@/pages/Me/index.vue'),
      },
    ],
  },
]
